import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete-esb';
import { NgxMaskModule } from 'ngx-mask';

import { DayInputModule } from '../day-input/day-input.module';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { AgreementTextComponent } from '../shared/components/agreement-text/agreement-text.component';
import { SharedModule } from '../shared/shared.module';
import { InviteSignupProcessAddressComponent } from './components/invite-signup-process-address/invite-signup-process-address.component';
import { InviteSignupProcessCongratulationsComponent } from './components/invite-signup-process-congratulations/invite-signup-process-congratulations.component';
import { InviteSignupProcessContractComponent } from './components/invite-signup-process-contract/invite-signup-process-contract.component';
import { InviteSignupProcessDetailsComponent } from './components/invite-signup-process-details/invite-signup-process-details.component';
import { InviteSignupProcessDialogComponent } from './components/invite-signup-process-dialog/invite-signup-process-dialog.component';
import { InviteSignupProcessIdentityComponent } from './components/invite-signup-process-identity/invite-signup-process-identity.component';
import { InviteSignupProcessPhoneComponent } from './components/invite-signup-process-phone/invite-signup-process-phone.component';
import { InviteSignupProcessSmsComponent } from './components/invite-signup-process-sms/invite-signup-process-sms.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressBarModule,
    PipesModule,
    GooglePlaceModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    DirectivesModule,
    NgxMaskModule.forChild(),
    DayInputModule,
    SharedModule,
    FormsModule,
    AgreementTextComponent,
    InviteSignupProcessDialogComponent,
    InviteSignupProcessIdentityComponent,
    InviteSignupProcessPhoneComponent,
    InviteSignupProcessSmsComponent,
    InviteSignupProcessAddressComponent,
    InviteSignupProcessContractComponent,
    InviteSignupProcessDetailsComponent,
    InviteSignupProcessCongratulationsComponent,
  ],
})
export class InviteSignupProcessModule {}
